import { render, staticRenderFns } from "./menuCards.vue?vue&type=template&id=29721c91&scoped=true&"
import script from "./menuCards.vue?vue&type=script&lang=js&"
export * from "./menuCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29721c91",
  null
  
)

export default component.exports